import React from 'react';
import styled from 'styled-components'
import { media } from '../styles/Mixin'
import BigText from './BigText';
import NormalText from './NormalText';
import Cookies from 'js-cookie'

const ProfileMobileWindow = ({
    history,
    setProfileBtn,
    channelId
}) => {
    return (
        <Wrapper>
            <Box>
                <Header>
                    <CustomBigText text={"선택"} />
                </Header>
                <Content>
                    <MyChannel> <CustomText text={"내 채널 가기"} onClick={() => { setProfileBtn(false); history.push(`/${channelId}`) }}/></MyChannel>
                    <MyInfo><CustomText text={"내정보"} onClick={() => { setProfileBtn(false); history.push(`/myinfo`) }}/></MyInfo>
                    <LogOut><CustomText text={"로그아웃"} onClick={() => { Cookies.remove("sessionId"); window.location.assign("/") }}/></LogOut>
                    <CancelBtn><CancelText text={"취소"} onClick={() => { setProfileBtn(false)}}/></CancelBtn>
                </Content>
            </Box>
        </Wrapper>
    )
}


export default ProfileMobileWindow

const Wrapper = styled.div`
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.5);
    height:100%;
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:10000;
`

const Box = styled.div`
   position:relative;
   display:flex;
   flex-direction:column;
   ${media.deskTop`
    width:500px;
    height:450px;
   `}
    ${media.mobile`
        width:100%;
        height:300px;
    `};
`

const Header = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    padding:10px;
    top:0;
    height:40px;
`

const CustomBigText = styled(BigText)`
    color:white;
    font-weight:bold;
`

const Content = styled.div`
    height:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    overflow-y: auto;
    ${media.deskTop`
        padding:20px;
        margin-top:30px;
   `};
    ${media.mobile`
        padding:15px;
        margin-top:20px;
    `};
    &>:not(:last-child){
      ${media.deskTop`
          margin-bottom:20px;
      `};
      ${media.mobile`
         margin-bottom:15px;
      `};
    };
`

const ShareBtn = styled.div`
    border-radius: ${props => props.theme.borderRadius};
    width:50%;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    padding:10px;
    cursor:pointer;
`

const MyChannel = styled(ShareBtn)`
    background-color:${props => props.theme.blueColor};
`

const MyInfo = styled(ShareBtn)`
    background-color:${props => props.theme.blueColor};
`

const LogOut = styled(ShareBtn)`
    background-color:red;
`

const CancelBtn = styled(ShareBtn)`
    background-color:${props => props.theme.lightCloudColor};

`
const CustomText = styled(NormalText)`
    color:white;
`

const CancelText= styled(NormalText)`
    color:black
`
